import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { PaginationModel } from '@shared/models/pagination.model';
import {PageUserListModel} from "@services/back-office/model/pageUserListModel";
import {UserListModel} from "@services/back-office/model/userListModel";
import {UserListSearchRequest} from "@services/back-office/model/userListSearchRequest";

export enum UsersActionTypes {
  LoadUsers = '[Users] Load Users',
  LoadUsersSuccess = '[Users] Load Users Success',
  LoadUsersFailure = '[Users] Load Users Failure',
  ChangeUsersStatus = '[Users] Change Users Status',
  ChangeUsersStatusSuccess = '[Users] Change Users Status Success',
  ChangeUsersStatusFailure = '[Users] Change Users Status Failure',
  ChangePage = '[Users] Change Page',
  SetInitialPagination = '[Users] Set Initial Pagination',
  SetFilter = '[Users] Set Filter',
  ClearFilter = '[Users] Clear Filter',
  SetInitialState = '[Users] Set Initial State',
}

/** Load Users */
export class LoadUsers implements Action {
  readonly type = UsersActionTypes.LoadUsers;
  constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadUsersSuccess implements Action {
  readonly type = UsersActionTypes.LoadUsersSuccess;
  constructor(public payload: PageUserListModel) { }
}

export class LoadUsersFailure implements Action {
  readonly type = UsersActionTypes.LoadUsersFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Change Users Status */
export class ChangeUsersStatus implements Action {
  readonly type = UsersActionTypes.ChangeUsersStatus;
  constructor(public payload: {id: string, user: UserListModel}) {}
}

export class ChangeUsersStatusSuccess implements Action {
  readonly type = UsersActionTypes.ChangeUsersStatusSuccess;
  constructor(public payload: {id: string, user: UserListModel}) { }
}

export class ChangeUsersStatusFailure implements Action {
  readonly type = UsersActionTypes.ChangeUsersStatusFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Change Page */
export class ChangePage implements Action {
  readonly type = UsersActionTypes.ChangePage;
  constructor(public payload: PaginationModel) {}
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
  readonly type = UsersActionTypes.SetInitialPagination;
}

/** Set Filter */
export class SetFilter implements Action {
  readonly type = UsersActionTypes.SetFilter;
  constructor(public payload: UserListSearchRequest) {}
}

/** Clear Filter */
export class ClearFilter implements Action {
  readonly type = UsersActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
  readonly type = UsersActionTypes.SetInitialState;
}

export type UsersActions =
  | LoadUsers
  | LoadUsersSuccess
  | LoadUsersFailure
  | ChangeUsersStatus
  | ChangeUsersStatusSuccess
  | ChangeUsersStatusFailure
  | ChangePage
  | SetInitialPagination
  | SetFilter
  | ClearFilter
  | SetInitialState
  ;

